import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource, MatDialog, PageEvent, MatPaginator } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
// import { DlgCitaprogramComponent } from './dlg-citaprogram/dlg-citaprogram.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
// import { ReasignacionModalComponent } from './reasignacion-modal/reasignacion-modal.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TipoServicioService } from '../tipo-servicio.service';
import { takeUntil, skip } from 'rxjs/operators';

@Component({
  selector: 'app-reporte-fallapersiste',
  templateUrl: './reporte-fallapersiste.component.html',
  styleUrls: ['./reporte-fallapersiste.component.scss']
})
export class ReporteFallapersisteComponent implements OnInit {
  private destroy$ = new Subject<void>();
  minDate = new Date();
  maxDate = new Date();
  agentes = [{
    idagente: 0,
    nombre: 'Todos'
  }];
  estados = [{
    id: 0,
    name: 'Todos'
  }, {
    id: 1,
    name: 'Pendiente de asignar'
  }, {
    id: 2,
    name: 'Asignada'
  }];
  tiempos = [
    {
      id: 0,
      name: 'Todos'
    },
    {
      id: 'AM',
      name: 'AM'
    },
    {
      id: 'PM',
      name: 'PM'
    }
  ];

  grupoVal = new FormGroup({
    BUSCAR: new FormControl(''),
    AGENTE: new FormControl(0),
    ESTADO: new FormControl(0),
    TIEMPO: new FormControl(0),
    FECHAINI: new FormControl(''),
    FECHAFIN: new FormControl(''),
    TIPO: new FormControl(3),
    ATENCION: new FormControl(''),
  });
  usuariosCant = 5;
  // ['CUENTA', 'NOMBRE', 'TELEFONO', 'FALLA', 'CAMPANA', 'MOTIVO', 'FECHA_RESP', 'ACCION'];
  tableColumns: string[] = ['TIPO_CANCEL', 'FALLA', 'CUENTA', 'CAMPANA', 'MOTIVO', 'FECHA_RESP', 'AGENTE', 'ATENCION'];

  dataSource = new MatTableDataSource<any>([]);
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  FILTER; resultsLength = 0;
  pageSize = 10;
  idpais;
  pageEvent: PageEvent
  public actpage: number = 0;
  @ViewChild('paginatortable') paginatortable: MatPaginator;
  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private _tipoServicio: TipoServicioService
  ) { }

  async ngOnInit() {
    this.grupoVal.controls.TIPO.setValue(3);
    this.grupoVal.controls.ATENCION.setValue(0);
    const user = this.localSave.get('usuarioPGV');
    await this.getTecnicosxContrata();
    if (!user || user.idrol != 1) {
      this.router.navigate(['/home']);
    }
    this.idpais = this.localSave.get('pais');
    this.get(0);
    this.pageTitle.title = 'Citas';
    // this.loadUsuarios();
    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrarAgente(res.filtro);
      });
    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        // this.createAgente();
      });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
    this._tipoServicio.notifyObservable$.pipe(
      skip(1)
    ).subscribe(async () => {
      await this.getTecnicosxContrata();
      this.get(0);
    });
  }

  // ============== FILTRO ==============
  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }
  public filtrogeneral() {
    if (this.paginatortable) {
      this.paginatortable.firstPage();
    }
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  getTecnicosxContrata() {
    const tipoActual = this._tipoServicio.getValorActual();
    return new Promise((resolve, reject) => {
      this.gateway.get('gettecnicosxcontrata', {
        IDPAIS: this.idpais,
        IDDISTRIBUIDOR: tipoActual.IDU,
        IDPADRE: tipoActual.IDPADRE,
        IDAREA: tipoActual.IDAREA
      }).then((result) => {
        let aux: any = result;
        if (aux.rows.length > 0) {
          this.agentes = aux.rows;
          this.agentes.unshift({ idagente: 0, nombre: 'Todos' });
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((e) => {
        reject(e);
      });
    })
  }

  get(page) {
    const tipoActual = this._tipoServicio.getValorActual();
    this.spinner.show();
    this.gateway.get('getClientesFallaPersistexContrata',
      {
        NUM_ELEMENTOS: this.pageSize,
        NUM_PAGINA: page,
        TIPO: 8,
        ATENCION: this.grupoVal.controls.ATENCION.value == 100 ? null : this.grupoVal.controls.ATENCION.value,

        IDAGENTE: this.grupoVal.controls.AGENTE.value,
        TIEMPO: this.grupoVal.controls.TIEMPO.value,
        IDESTADO: this.grupoVal.controls.ESTADO.value,
        FECHAINI: this.grupoVal.controls.FECHAINI.value,
        FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
        FILTRO: this.FILTER,
        IDPAIS: this.idpais,
        IDDISTRIBUIDOR: tipoActual.IDU,
        IDPADRE: tipoActual.IDPADRE,
        IDAREA: tipoActual.IDAREA
      }).then((result) => {

        let aux: any = result;
        this.dataSource = aux.rows;
        //this.resultsLength = 3//;result[1][0].TOTAL;

        this.gateway.get('getContClientesFallaPersistexContrata', {
          NUM_ELEMENTOS: this.pageSize,
          NUM_PAGINA: page,
          TIPO: 8,
          ATENCION: this.grupoVal.controls.ATENCION.value == 100 ? null : this.grupoVal.controls.ATENCION.value,

          IDAGENTE: this.grupoVal.controls.AGENTE.value,
          TIEMPO: this.grupoVal.controls.TIEMPO.value,
          IDESTADO: this.grupoVal.controls.ESTADO.value,
          FECHAINI: this.grupoVal.controls.FECHAINI.value,
          FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
          FILTRO: this.FILTER,
          IDPAIS: this.idpais,
          IDDISTRIBUIDOR: tipoActual.IDU,
          IDPADRE: tipoActual.IDPADRE,
          IDAREA: tipoActual.IDAREA
        }).then((result: any) => {
          this.resultsLength = result.rows[0].total;
          this.spinner.hide();
        });

      }
      ).catch(function (e) {
      });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscriptioncreate) this.subscriptioncreate.unsubscribe();
    if (this.subscriptionpais) this.subscriptionpais.unsubscribe();
  }

  // createAgente() {
  //   const dialogRef = this.dialog.open(CreateAgenteComponent, {
  //     maxWidth: '130vw',
  //     width: '900px',
  //     minHeight: '50vh',
  //     data: { operacion: 'Crear', agente: { idpais: this.idpais } },
  //     disableClose: true
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //     this.get(this.actpage);
  //   });
  // }

  filtrarAgente(data) {
    this.FILTER = data;
    this.get(0)
  }

  edit(element: any) {
    // console.log('cita:', element)
    // //element.idpais = this.idpais;
    // const dialogRef = this.dialog.open(DlgCitaprogramComponent, {
    //   maxWidth: '130vw',
    //   width: '600px',
    //   minHeight: '30vh',
    //   data: { operacion: 'Editar', agente: element },
    //   disableClose: true
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.get(this.actpage);
    //   }
    // });
  }

}
